module.exports = __webpack_public_path__ + "img/d68b0a9.jpg";